class TextInput extends HTMLElement {
  showError(errorMessage) {
    this.querySelector('[data-error]').innerHTML = errorMessage
    this.classList.add('has-error')
  }

  hideError() {
    this.querySelector('[data-error]').innerHTML = ''
    this.classList.remove('has-error')
  }
}

customElements.define('text-input', TextInput)
